<button aria-label="Open search modal" type="button" class="btn btn-icon" (click)="open(); searchBar.focusInput()">
  <span class="sr-only" i18n="@@SEARCH">SEARCH</span>
  <img class="search-icon" alt="search icon" [src]="'assets/images/icons/search.svg' | staticFileHash" />
</button>

<div class="search-modal modal" [ngClass]="{ visible: modalOpen() }" (click)="close()">
  <div class="modal-body modal-dialog" [ngClass]="{ show: modalOpen() }" (click)="$event.stopPropagation()">
    <div class="container">
      <app-search-bar #searchBar />
    </div>
  </div>
</div>
